<template>
  <v-card>
    <item-media :value='value'/>
    <item-title :value='value'/>
    <v-divider></v-divider>
    <item-actions :value='value'/>
  </v-card>
</template>

<script>
import itemMedia from '../Media'
import itemTitle from '../Title'
import itemActions from '../Actions'
export default {
  name: 'item-card',
  props: ['value'],
  components: {
    'item-media': itemMedia,
    'item-title': itemTitle,
    'item-actions': itemActions
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?06807013